module.exports = __webpack_public_path__ + "ccc1f46f717ef607d89094c5fdf846a9.png";